import React, {  useState } from "react";
import { Link, useNavigate} from "react-router-dom"; // Adjust the import path accordingly
import { useSignup } from "../../../hooks/useSignup";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ClipLoader } from 'react-spinners'; // Optional spinner library
import { showToast } from "../../../utils/Toast";
import BenefitsSection from "./BenefitsSection";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Signup = () => {
  const [showPassword, setShowPassword] = useState(false); 
  const navigate = useNavigate()

  const signupValidationSchema = Yup.object().shape({
    username: Yup.string().required("Full name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: Yup.string()
      .required("Phone number is required")
      .min(10, "Please enter a valid phone number")
      .test("phone", "Please enter a valid phone number", (value) => {
        if (!value) return false;
        // Remove the country code prefix (e.g., +1) and any non-digit characters
        const phoneNumberWithoutCountryCode = value.replace(/^\+\d+/, '').replace(/\D/g, '');
        return phoneNumberWithoutCountryCode.length >= 10;
      }),
    password: Yup.string().required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const { signup, isLoading } = useSignup();

  const signupFormik = useFormik({
    initialValues: {
      username: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: signupValidationSchema,
    onSubmit: async (values) => {
      const { success, message } = await signup(values);
      if (success) {
        showToast(message, 'success');
        document.getElementById("registration_success_modal").showModal();
        // toast.success(message);
        // navigate("/");
      } else {
        // toast.error(message);
        showToast(message, 'error');

      }
    },
    validateOnChange: true,
    validateOnBlur: true,
  });

  const closeSuccessModal = () => {
    document.getElementById("registration_success_modal").close();
    navigate('/login')
  };

  return (
    <>
     <div className="hidden lg:block signup">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">Sign Up</div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
            Sign Up
            </button>
          </div>
        </div>
      </div>
      <div className=" py-[100px] lg:py-[9.3vh] w-full lg:w-[36.1] mx-auto">
        <div className="mt-[8.6vh] text-[24px] lg:text-[2vw] font-bold font-urbanist">
          Register To BidCaribbean
        </div>
        <form className="flex flex-col items-center gap-[2.5vh] mt-[6vh] mx-auto justify-center" onSubmit={signupFormik.handleSubmit}>
          <input
            type="text"
            id="username"
            name="username"
            className={`w-[300px] sm:w-[342px]  lg:w-[35vw] h-[48px] lg:h-[5.23vh] rounded-lg pl-2 border text-[14px] lg:text-[1vw] ${
              signupFormik.touched.username && signupFormik.errors.username
                ? "border-red-600 placeholder-red-500"
                : "border-gray-300"
            }`}
            placeholder={
              signupFormik.touched.username && signupFormik.errors.username
                ? signupFormik.errors.username
                : "Your Full name*"
            }
            onChange={signupFormik.handleChange}
            onBlur={signupFormik.handleBlur}
            value={signupFormik.values.username}
          />
          <input
            type="email"
            id="email"
            name="email"
            className={`w-[300px] sm:w-[342px]  lg:w-[35vw] h-[48px] lg:h-[5.23vh] rounded-lg pl-2 border text-[14px] lg:text-[1vw]  ${
              signupFormik.touched.email && signupFormik.errors.email
                ? "border-red-600 placeholder-red-500"
                : "border-gray-300"
            }`}
            placeholder={
              signupFormik.touched.email && signupFormik.errors.email
                ? signupFormik.errors.email
                : "Your Email Address*"
            }
            onChange={signupFormik.handleChange}
            onBlur={signupFormik.handleBlur}
            value={signupFormik.values.email}
          />
          {/* <CountryDropdown countries={countries} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} /> */}
    

    <div className=" w-[300px] sm:w-[342px] lg:w-[35vw] h-[48px] lg:h-[5.23vh] ">
                    <PhoneInput
                      country={"us"}
                      countryCodeEditable={true}
                      disableDropdown={true}
                      buttonStyle={{
                        background: "white",
                        borderRight: "0px",
                        height: "100%", // Ensure the button takes full height
                        width: "auto", // Adjust width as needed
                      }}
                      containerClass="mx-auto h-full border-none outline-none p-0 m-0"
                      inputProps={{
                        name: "phone",
                        required: true,
                        placeholder: signupFormik.touched.phone && signupFormik.errors.phone
                          ? signupFormik.errors.phone
                          : "Your Phone Number*"
                      }}

                      inputStyle={{ 
                        width: "100%",
                        height:"100%",
                        borderColor: signupFormik.touched.phone && signupFormik.errors.phone ? '#dc2626' : '#d1d5db',
                        fontSize: "clamp(12px, 1.2vw, 16px)" 

                      }}
                      value={signupFormik.values.phone}
                      onChange={(phone) => {
                        signupFormik.setFieldValue("phone", phone);
                        signupFormik.setFieldTouched("phone", true);
                      }}
                      onBlur={signupFormik.handleBlur}
                    />
                  </div>


          <input
             type={showPassword ? "text" : "password"} 
            id="password"
            name="password"
            className={`w-[300px] sm:w-[342px]  lg:w-[35vw] h-[48px] lg:h-[5.23vh] rounded-lg pl-2 border text-[14px] lg:text-[1vw] ${
              signupFormik.touched.password && signupFormik.errors.password
                ? "border-red-600 placeholder-red-500"
                : "border-gray-300"
            }`}
            placeholder={
              signupFormik.touched.password && signupFormik.errors.password
                ? signupFormik.errors.password
                : "Your Password*"
            }
            onChange={signupFormik.handleChange}
            onBlur={signupFormik.handleBlur}
            value={signupFormik.values.password}
          />
         
          <input
             type={showPassword ? "text" : "password"} 
            id="confirmPassword"
            name="confirmPassword"
            className={`w-[300px] sm:w-[342px]  lg:w-[35vw] h-[48px] lg:h-[5.23vh] rounded-lg pl-2 border text-[14px] lg:text-[1vw] ${
              signupFormik.touched.confirmPassword &&
              signupFormik.errors.confirmPassword
                ? "border-red-600 placeholder-red-500"
                : "border-gray-300"
            }`}
            placeholder={
              signupFormik.touched.confirmPassword &&
              signupFormik.errors.confirmPassword
                ? signupFormik.errors.confirmPassword
                : "confirm Password *"
            }
            onChange={signupFormik.handleChange}
            onBlur={signupFormik.handleBlur}
            value={signupFormik.values.confirmPassword}
          />
          <div>
            {signupFormik.touched.confirmPassword &&
            signupFormik.errors.confirmPassword ? (
              <p className="text-[14px] text-red-700 text-left">Password did not match</p>
            ) : null}
          </div>
          <div className="w-[300px] sm:w-[342px]  lg:w-[34vw] flex justify-between">
            <div className="flex justify-between items-center gap-[0.5vw] text-[14px] lg:text-[1vw]">
              <input
                type="checkbox"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)} 
                className="form-checkbox text-[14px] flex"
              />
              Show Password 
            </div>
            {/* <div className="font-urbanist text-[14px] lg:text-[1vw] font-semibold">
              Forget password?
            </div> */}
          </div>
          <button className="w-[300px] sm:w-[342px]  lg:w-[36vw] h-[5.23vh] bg-primary-red text-white text-[14px] lg:text-[0.9vw] rounded-full mt-[2vh] ">
          {isLoading ? <ClipLoader size={20} color={"#fff"} /> : "Register Now"}
          </button>
        </form>
        <div className="text-[14px] lg:text-[1vw] font-urbanist mt-[5vh]">
          Already have an account?
          <Link to="/login">
            <span className="text-[#ca0000] cursor-pointer"> Sign in</span>
          </Link>
        </div>
        <BenefitsSection />
      </div>

        {/* Registration Success Modal */}
        <dialog id="registration_success_modal" className="modal">
        <div className="modal-box dark:bg-white font-urbanist">
          <div className="text-center">
            <div className="mb-4 text-green-600">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 className="font-bold text-lg">Registration Successful!</h3>
            <p className="py-4">
              Thank you for registering with BidCaribbean. Please check your email to verify your account.
            </p>
            <div className="flex gap-x-2 justify-center">
              <button
                className="btn text-green-600 dark:bg-white hover:bg-gray-200 border-green-600"
                onClick={closeSuccessModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default Signup;
